













import Vue from "@/shim-vue";
import { Component, Prop, Watch } from 'vue-property-decorator';

import config from "@/config/toast";

@Component({
    name: "LoniToast"
})
export default class LoniToast extends Vue {
    /** 消息内容 */
    @Prop()
    public message?: string;

    /** 出现位置 */
    @Prop()
    public position?: "top" | "middle" | "bottom";

    /** 显示时长，单位毫秒。值为0或负数不消失 */
    @Prop()
    public duration?: number;

    /** 背景色 */
    @Prop()
    public background?: string;

    /** 点击事件穿透 */
    @Prop({ type: Boolean, default: undefined })
    public eventPenetrate?: boolean;

    /** 是否在页面切换时自动关闭 */
    @Prop({ type: Boolean, default: undefined })
    public closeOnPopstate?: boolean;

    private visible = false;

    public get options() {
        return {
            position: this.position ?? config.position,
            duration: this.duration ?? config.duration,
            background: this.background ?? config.background,
            eventPenetrate: this.eventPenetrate ?? config.eventPenetrate,
            closeOnPopstate: this.closeOnPopstate ?? config.closeOnPopstate
        }
    }

    public close() {
        this.visible = false;
        setTimeout(() => {
            this.$emit("close");
        }, 300);
    }

    @Watch("visible")
    private onVisibleChanged() {
        if(this.visible) {
            if(this.options.duration > 0) {
                setTimeout(this.close, this.options.duration);
            }
            if(this.options.closeOnPopstate) {
                window.addEventListener("popstate", this.close);
            }
        } else {
            if(this.options.closeOnPopstate) {
                window.removeEventListener("popstate", this.close);
            }
        }
    }
}
